import { cn } from '@/shared/lib/utils';
import { Fragment } from 'react';

/**
 * 의약품 메타 줄 — 값 사이에 4px 회색 점(grey-400), 간격 8 (Figma 검색_결과 sub info · 드로어 833:6671)
 * 글자 크기 · 색은 className으로 넘긴다 (결과 카드 13 · 드로어 · 동일성분 15).
 */
export const DrugMeta = ({
  items,
  className,
}: {
  items: (string | null | undefined | false)[];
  className?: string;
}) => {
  const values = items.filter((v): v is string => !!v);
  if (values.length === 0) return null;
  return (
    <p className={cn('flex flex-wrap items-center gap-x-2', className)}>
      {values.map((v, i) => (
        <Fragment key={`${v}-${i}`}>
          {i > 0 && (
            <span
              aria-hidden
              className="size-1 shrink-0 rounded-full bg-grey-400"
            />
          )}
          <span className="whitespace-nowrap">{v}</span>
        </Fragment>
      ))}
    </p>
  );
};
